import { Component, OnInit, ViewChild, AfterViewInit, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { AuthService } from '@core/services/auth-service/auth.service';
import { PusherV2Service } from '@core/services/contact/pusherV2.service';
import { FeatureService } from '@core/services/feature/features.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { StripeService } from '@core/services/stripeService/stripe-service.service';
import { DownGradeModalComponent } from '@shared/modals/down-grade-modal/down-grade-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
  modalRef?: BsModalRef;
  subscription: any = null;
  hasSubscription: boolean = false;
  requiresDowngradeAction: boolean = false;
  currentFeatureUsage: any = [];

  redirectionType: number | null = null;
  idCompany: any;

  constructor(
    private modalService: BsModalService,
    private localStorageService: LocalStorageService,
    private cdr: ChangeDetectorRef,
    private featuresService: FeatureService,
    private toastr: ToastrService,
    private stripeService: StripeService,
    private authService: AuthService,
    private pusherV2Service: PusherV2Service,
    private router: Router
  ) {}

  ngOnInit(): void {    
    const connectedUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}')      
    this.idCompany = connectedUser?.company?.uuid
    

    if (history?.state?.redirectionType || this.localStorageService.getData('redirectionType') ) {
      this.planUpgradeInform();
    } else{
      this.listenerPlanChange();
      this.getActiveSubscription();
    }

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navigationEndEvent = event as NavigationEnd;
        if (!navigationEndEvent.url.startsWith('/candidats/compare-candidats') && navigationEndEvent.url !== '/candidats/result-compare') {
          localStorage.removeItem('skillScore');
          localStorage.removeItem('experienceScore');
          localStorage.removeItem('languageScore');
          localStorage.removeItem('availabilityScore');
        }
        if (!navigationEndEvent.url.startsWith('/offres-emploi/edit-offre-emploi') &&navigationEndEvent.url !== '/offres-emploi/ajout-offre-emploi'){
          sessionStorage.removeItem('hasRefreshed')
        }
      });
  }
  getActiveSubscription(): void {

    this.stripeService.getActiveSubscriptionPlan().subscribe(subscription => {
    if (subscription?.data) {
      this.localStorageService.saveData(
        'subscription',
        JSON.stringify(subscription.data)
      );
      this.subscription = subscription.data;
      this.hasSubscription = true;
      this.cdr.detectChanges();
      this.getFeatureUsageAndCheckExeeds();
    } else {
      this.hasSubscription = false;
      this.localStorageService.removeData('subscription');
      this.cdr.detectChanges();
    }
   })
  }
  getFeatureUsageAndCheckExeeds(): void {
    this.featuresService.getFeatureUsage().subscribe({
      next: (res: any) => {
        this.currentFeatureUsage = res.data;
        this.checkExceedsMaxUsage();
        
        if (this.requiresDowngradeAction) {
          const initialState: any = {
            subscription: this.subscription,
            hasSubscription: this.hasSubscription,
            currentFeatureUsage: this.currentFeatureUsage,
          };

          this.modalRef = this.modalService.show(DownGradeModalComponent, {
            initialState,
            backdrop: 'static',
            keyboard: false,
          });
        }
      },
      error: () => {
        this.toastr.error('Échec de la récupération de l’utilisation de l’abonnement actif');
      },
    });
  }

  checkExceedsMaxUsage(): void {
    if (this.hasSubscription) {
      for (const feature of this.subscription.features) {        
        const currentUsage = this.currentFeatureUsage.find((f: any) => f.id === feature.id);
        if (currentUsage) {
          const maxUsage = feature.pivot?.metadata?.max_usage;
          const currentUsed = currentUsage.used;

          if (maxUsage !== null && maxUsage !== -1 && currentUsed > maxUsage) {
            this.requiresDowngradeAction = true;
            return;
          }
        }
      }
    }
    this.requiresDowngradeAction = false;
  }

  planUpgradeInform() {
    Swal.fire({
        title: 'Abonnement activé avec succès',
        text: "Afin d'assurer la prise en compte des nouvelles conditions, toutes les sessions actives de votre entreprise vont être déconnectées. Les utilisateurs devront se reconnecter pour bénéficier pleinement des fonctionnalités liées à cet abonnement.",
        icon: 'warning',
        confirmButtonColor: '#3085D6',
        confirmButtonText: 'Fermer',
      }).then((result) => {        
        if(result.isConfirmed || result.isDismissed){
          this.toastr.success("Merci pour votre compréhension. Votre nouvelle souscription est désormais active.");
          this.authService.logOut();
        }
        
      });
  }

  listenerPlanChange() {

    this.pusherV2Service.listen(
      `company-plan-upgraded.${this.idCompany}`,
      'App\\Events\\CompanyPlanUpgraded',
      (result: any) => {
        this.planUpgradeInform();
      }
    );
  }
}
